/**
 * Provider工厂
 *
 * 外部不直接new具体服务商
 *
 * 后续切换:
 * aliyun -> doubao
 * 只修改这里
 */

import {
    PROVIDER_TYPE
} from "../constants/ProviderConstants";

import AliyunProvider from "./aliyun/AliyunProvider";

export default class ProviderFactory{

    /**
     * 创建语音服务
     *
     * @param type 服务商类型
     * @param config 配置参数
     */
    static create(type,config={}){
        switch(type){
            case PROVIDER_TYPE.ALIYUN:
                return new AliyunProvider(config);

            default:
                throw new Error(`不支持的TTS服务:${type}`);
        }
    }
}